export * from './shortcuts.component';
